 import baseStorage from './baseStorage'
 export default {
     keyword: 'userInfo',
     setUserInfo(value) {
         baseStorage.setStorage(this.keyword, JSON.stringify(value))
     },
     getUserInfo() {
         var userinfo = baseStorage.getStorage(this.keyword);
         if (userinfo)
             return JSON.parse(userinfo)
         return null
     },
     removeUserInfo() {
         baseStorage.removeStorage(this.keyword);
     },
     PerfectInformation: 'PerfectInformation',
     setPerfectInformation(value) {
         baseStorage.setStorage(this.PerfectInformation, JSON.stringify(value))
     },
     getPerfectInformation() {
         var value = baseStorage.getStorage(this.PerfectInformation);
         if (value)
             return JSON.parse(value)
         return false
     },
     Verifyphonenumber: 'Verifyphonenumber',
     setVerifyphonenumber(value) {
         baseStorage.setStorage(this.Verifyphonenumber, JSON.stringify(value))
     },
     getVerifyphonenumber() {
         var value = baseStorage.getStorage(this.Verifyphonenumber);
         if (value)
             return JSON.parse(value)
         return false
     },
     Useridentity: 'Useridentity',
     setUseridentity(value) {
         baseStorage.setStorage(this.Useridentity, JSON.stringify(value))
     },
     getUseridentity() {
         var value = baseStorage.getStorage(this.Useridentity);
         if (value)
             return JSON.parse(value)
         return false
     },
     UnionId: 'UnionId',
     setUnionId(value) {
         baseStorage.setStorage(this.UnionId, JSON.stringify(value))
     },
     getUnionId() {
         var value = baseStorage.getStorage(this.UnionId);
         if (value)
             return JSON.parse(value)
         return false
     },
     UserOnline: 'UserOnline',
     setUserOnline(value) {
         baseStorage.setStorage(this.UserOnline, JSON.stringify(value))
     },
     getUserOnline() {
         var value = baseStorage.getStorage(this.UserOnline);
         if (value)
             return JSON.parse(value)
         return null
     },
     external: 'external',
     setExternal(value) {
         baseStorage.setStorage(this.external, JSON.stringify(value))
     },
     getExternal() {
         var value = baseStorage.getStorage(this.external);
         if (value)
             return JSON.parse(value)
         return false
     },
     Ischangepassword: 'N',
     setIschangepassword(value) {
         baseStorage.setStorage(this.Ischangepassword, JSON.stringify(value))
     },
     getIschangepassword() {
         var value = baseStorage.getStorage(this.Ischangepassword);
         if (value)
             return JSON.parse(value)
         return false
     },
 }


// WEBPACK FOOTER //
// ./src/utils/storage/userStorage.js